<dashboard-dialog-frame [header]="'Add Mentor'" [dialogRef]='dialogRef' [actions]="actions()">

	<div class="p-3">
		<person-finder-widget searchLabel='Search Person' (selectedRowId)="setSelectedPersonId($event)"></person-finder-widget>

		@if(mentorValidation(); as message) {
		<div class="my-3" [ngClass]="message.isWarning ? 'text-danger' : 'text-success'">
			<p>
				{{ message.text }}
			</p>
			@if(message.subText) {
			<p>{{ message.subText }}</p>
			}
		</div>
		}
	</div>

</dashboard-dialog-frame>